export default {
  status: state => state.status,
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  retrospectiveDay: state => state.retrospectiveDay,
  reviewRequestStatistics: state => state.reviewRequestStatistics
}



// WEBPACK FOOTER //
// ./src/store/modules/review-requests/getters.js